import * as React from "react";
import { AppBundle } from "gen/clients";
import { ConfirmationDialog } from "components/ConfirmationDialog/ConfirmationDialog";
import Typography from "@mui/material/Typography";

interface Props {
  appBundle: AppBundle;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

const DisableAppBundleDialog: React.FC<Props> = ({ appBundle, onClose, onConfirm, isLoading }) => {
  const isDisabling = !appBundle.isDisabled;
  const action = isDisabling ? "disable" : "enable";
  const actionCapitalized = isDisabling ? "Disable" : "Enable";

  return (
    <ConfirmationDialog
      title={`${actionCapitalized} App Bundle`}
      content={
        <Typography>
          Are you sure you want to {action} the app bundle "{appBundle.name}"?
          {isDisabling && (
            <>
              <br />
              <br />
              <strong>Note:</strong> Disabled app bundles will not be available for assignment to clients.
            </>
          )}
        </Typography>
      }
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
      confirmationButtonColor={isDisabling ? "warning" : "success"}
    />
  );
};

export { DisableAppBundleDialog };
